<div fxLayout="column"></div>
    <mat-card [style.background-color]="uiData.firm.color">
        <mat-card-title>
           Select an option
        </mat-card-title>
    </mat-card>
    <div>    
<div class="checkbox-container">
    
    <mat-checkbox [(ngModel)]="selectedCertificates" value="certificate">Certificate</mat-checkbox>
    <mat-checkbox [(ngModel)]="selectedLetters" value="letter">Letter</mat-checkbox>
</div>
    <mat-card [style.background-color]="uiData.firm.color" fxLayout="row wrap" fxLayoutGap="8px">    
      <button [disabled]="!selectedCertificates && !selectedLetters" mat-raised-button color="primary" (click)="onPrintClick()">Print</button>
      <button mat-raised-button (click)="onCancel()">Cancel</button>        
    </mat-card>
  </div>